import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { logout } from '../../store/slices/authSlice';
import Sidebar from './Sidebar';
import './MainLayout.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleNavigateHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="main-layout">
      <nav className="main-nav">
        <div className="nav-brand" onClick={handleNavigateHome} style={{ cursor: 'pointer' }}>
          <h2>iPlug Chatbot</h2>
        </div>
        <div className="nav-user">
          <span className="user-name">{user?.name}</span>
          <button onClick={handleLogout} className="logout-button">
            Cerrar Sesión
          </button>
        </div>
      </nav>
      <div className="layout-body">
        <Sidebar />
        <main className="main-content">{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
